import React, { useState } from "react";

import { CartProduct } from "@app/scripts/react-cart/components/CartProduct";
import { CartCollection } from "@app/scripts/react-cart/components/CartCollection";
import { ProductRecommendations } from "@app/scripts/react-product-recommendations/components/ProductRecommendations";
import { CartGwpPlaceholder } from "@app/scripts/react-hooks/cartGwpPlaceholder";
import type { Cart, NormalisedProduct } from "@app/scripts/types";

type Props = {
  cart: Cart | null;
  products: NormalisedProduct[];
  handleUpdate: (variantId: number, qty: number, refresh?: boolean) => Promise<void>;
  addOosVariant: (variantId: number) => void;
  giftId?: string | number;
  giftMessage?: string | null;
  lowStockThreshold: number;
  notifyLabel: string;
  youMayAlsoLikeHeading?: string;
  youMayAlsoLikeCollection?: number[];
  youMayAlsoLikeProductsToShow: number;
  giftsInCart?: any
  overGiftThreshold?: boolean
  giftIds?: string[]
  untilGiftThreshold?: number,
};

export const CartItems: React.FC<Props> = ({
  cart,
  products,
  handleUpdate,
  addOosVariant,
  giftId,
  giftMessage,
  lowStockThreshold,
  notifyLabel,
  youMayAlsoLikeHeading,
  youMayAlsoLikeCollection,
  youMayAlsoLikeProductsToShow,
  giftsInCart,
  overGiftThreshold,
  untilGiftThreshold,
  giftIds,
}) => {

  const [active, setActive] = useState(true);
  const hasGiftsInCart = !!giftsInCart?.length;

  return cart && cart.items.length > 0 ? (
    <div className="cart__items">
      <div className="cart__items-inner">
        <div className="cart__items-wrapper">

          {overGiftThreshold && !hasGiftsInCart && giftIds?.length > 1 && (
            <div className="cart__recommendations free__gifts">
              <div className="text-brand-dark-grey mb-4 label" onClick={() => setActive(!active)}>
                Add your free gift
              </div>
              <CartCollection
                productIds={giftIds}
                disabledDesktop={false}
                disabledMobile={false}
                columnsDesktop={"auto"}
                columnsMobile={0.8}
                hasQuickAddDrawer={false}
                active
                addToCartBtns
                addAsGift
                arrowsMobile
              />
            </div>
          )}

          {giftIds && giftIds.length > 0 && !overGiftThreshold && !hasGiftsInCart ? <CartGwpPlaceholder
            productIds={giftIds}
            untilGiftThreshold={untilGiftThreshold}
          />
            : null
          }

          {cart.items.map((lineItem) => (
            <CartProduct
              giftIds={giftIds}
              key={lineItem.id}
              products={products}
              lineItem={lineItem}
              handleUpdate={handleUpdate}
              cart={cart}
              addOosVariant={addOosVariant}
              giftId={giftId}
              giftMessage={giftMessage}
              lowStockThreshold={lowStockThreshold}
              notifyLabel={notifyLabel}
            />
          ))}
        </div>

        {products?.length === 1 ? (
          <div className="cart__recommendations">
            {youMayAlsoLikeHeading && <h4 className="text-brand-dark-grey mb-4">{youMayAlsoLikeHeading}</h4>}

            {youMayAlsoLikeCollection?.length ? (
              <CartCollection
                productIds={youMayAlsoLikeCollection}
                disabledDesktop={false}
                disabledMobile={false}
                columnsDesktop="auto"
                columnsMobile="auto"
              />
            ) : (
              <ProductRecommendations
                productId={products[0].id}
                productsToShow={youMayAlsoLikeProductsToShow}
                disabledDesktop={false}
                disabledMobile={false}
                columnsDesktop={1.5}
                columnsMobile="auto"
                quickAddStyle="default"
                spaceBetween={16}
              />
            )}
          </div>
        ) : null}
      </div>
    </div>
  ) : (
    <div className="cart__items-empty text-md text-color-dark-grey">Your cart is empty.</div>
  );
}
